import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bitbucket': {
    width: 499,
    height: 512,
    paths: [
      {
        d: 'M16.2 31.6l466.8 0.2c1 0 1.9 0.1 2.8 0.2 8.7 1.4 14.6 9.6 13.2 18.3l-67.9 416.8c-1.3 7.8-8.1 13.5-16 13.4h-325.7c-10.6-0.1-19.6-7.8-21.3-18.2l-67.9-412.1c-0.1-0.9-0.2-1.9-0.2-2.8 0.1-8.9 7.4-15.9 16.2-15.8zM302.1 329.4l25.2-147h-157.3l28.1 147h104z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/bitbucket.js
// module id = null
// module chunks = 